import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

function MyAnimations() {
  const [animations, setAnimations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(null);

  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(`https://frogland.onrender.com/animations/${email}`);
      setAnimations(response.data.map(animation => ({
        ...animation,
        videoUrl: animation.videoUrl
      })));
      setSubmitted(true);
      localStorage.setItem('userEmail', email);
    } catch (error) {
      setError('Failed to fetch animations. Please try again.');
      console.error('Error fetching animations:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const savedEmail = localStorage.getItem('userEmail');
    if (savedEmail) {
      setEmail(savedEmail);
    }
  }, []);

  if (loading) {
    return (
      <div className="container">
        <div className="loading-container">
          <div className="spinner"></div>
          <p className="text-light">Loading your animations...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      <div className="nav-links">
        <Link to="/" className="nav-link">
          Create New Animation
        </Link>
      </div>
      
      <div className="main-content dark-theme">
        <h1 className="text-orange">My Animations</h1>
        
        {!submitted ? (
          <div className="email-form-container">
            <h2 className="text-light">Enter your email to view your animations</h2>
            <form onSubmit={handleEmailSubmit} className="email-form">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                className="text-input dark-input"
                autoComplete="email"
              />
              <button type="submit" className="convert-button">
                View My Animations
              </button>
            </form>
          </div>
        ) : (
          <>
            {animations.length > 0 ? (
              <div className="animations-grid">
                {animations.map(animation => (
                  <Link 
                    to={`/video/${animation.videoId}`} 
                    key={animation.videoId} 
                    className="animation-card dark-card"
                  >
                    <div className="preview-container">
                      {animation.status === 'completed' ? (
                        <video 
                          src={animation.videoUrl} 
                          autoPlay 
                          muted 
                          loop 
                          className="preview-video"
                        />
                      ) : (
                        <div className="processing-preview">
                          <div className="spinner"></div>
                          <p>Processing...</p>
                        </div>
                      )}
                    </div>
                    <div className="animation-status">
                      <span className={`status-badge status-${animation.status.toLowerCase()}`}>
                        {animation.status}
                      </span>
                    </div>
                    <div className="animation-details">
                      <p className="text-light">Created: {new Date(animation.createdAt).toLocaleDateString()}</p>
                      {animation.completedAt && (
                        <p className="text-light">Completed: {new Date(animation.completedAt).toLocaleDateString()}</p>
                      )}
                    </div>
                  </Link>
                ))}
              </div>
            ) : (
              <div className="no-animations">
                <p className="text-light">No animations found for this email address.</p>
                <button 
                  onClick={() => setSubmitted(false)} 
                  className="convert-button"
                >
                  Try Different Email
                </button>
              </div>
            )}
          </>
        )}

        {error && (
          <div className="error-message">
            {error}
          </div>
        )}
      </div>
    </div>
  );
}

export default MyAnimations; 